import React, { useEffect, useState } from "react";
import Head from "next/head";
import { getAboutUs_req } from "../api/api";
import Page from "../components/Page";
import Banner from "../components/banner";
import Slider from "react-slick";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";

const About = () => {
  const intl = useIntl();
  const [aboutUsData, setAboutUsData] = useState(null);
  const [aboutUsText, setAboutUsText] = useState(false);

  const langData = useSelector((state) => state.global.locale);

  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "400px",
    slidesToShow: 1,
    speed: 500,
    responsive: [
      {
        breakpoint: 1260,
        settings: {
          slidesToShow: 1,
          centerPadding: "300px",
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          centerPadding: "240px",
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          centerPadding: "160px",
        },
      },
      {
        breakpoint: 620,
        settings: {
          slidesToShow: 1,
          centerPadding: "100px",
        },
      },
      {
        breakpoint: 460,
        settings: {
          slidesToShow: 1,
          centerPadding: "40px",
        },
      },
    ],
  };

  const aboutUsReq = async () => {
    const lang = localStorage.getItem("lang");

    const aboutUsDataReq = await getAboutUs_req(lang);

    if (aboutUsDataReq.text) {
      setAboutUsText(true);
    }
    setAboutUsData(aboutUsDataReq);
  };
  useEffect(() => {
    aboutUsReq();
  }, [langData]);
  const aboutusText = aboutUsData?.text;

  const addText = () => {
    return { __html: aboutusText };
  };

  return (
    <Page
      meta={{
        title: intl.messages.aboutUs_title,
        description: intl.messages.aboutUs_desc,
      }}
    >
      <Head>
        <link
          rel="stylesheet"
          type="text/css"
          charSet="UTF-8"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
      </Head>
      <div className="about">
        <Banner
          title={intl.messages.aboutUs}
          currentPage={intl.messages.aboutUs}
        />
        <div className="about-slider">
          <Slider {...settings}>
            {aboutUsData?.slider?.map((item) => (
              <div key={item.id}>
                <img
                  src={item.image}
                  alt=""
                />
              </div>
            ))}
          </Slider>
        </div>
        <div className="wrapper">
          <div className="about-box">
            {aboutUsText ? (
              <div
                className="card card-body"
                dangerouslySetInnerHTML={addText()}
              />
            ) : null}
          </div>
        </div>
      </div>
    </Page>
  );
};

export default About;
